import React, { Fragment, useEffect, useState } from "react";
// eslint-disable-next-line
// import axios from "axios";
import app from "../util/firebase";
import {
  getDatabase,
  ref,
  set,
  get,
  update,
  push,
  orderByChild,
  equalTo,
  query,
  remove,
  onValue,
} from "firebase/database";
import Tasks from "../components/tasks";
import Environment from "../components/environment";
import Monitor from "../components/monitor";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { SnackbarProvider, useSnackbar } from "notistack";
import Button from "@mui/material/Button";
const drawerWidth = 240;

function HomePage() {
  // const [totalSittingTime, setTotalSittingTime] = useState(0);
  // const [timeStamp, setTimeStamp] = useState(new Date().getTime());
  // const [timePercent, setTimePercent] = useState(0);
  const [renderTodos, setRenderTodos] = useState(true);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [sendNotification, setSendNotification] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const db = getDatabase(app);
  const da6dRef = query(ref(db, "da6d"));
  const motionNotificationRef = query(ref(db, "da6d/" + "motion"));
  const notificationRef = query(ref(db, "da6d/" + "motion/" + "notification"));
  const totalSittingTimeRef = query(
    ref(db, "da6d/" + "motion/" + "totalSittingTime")
  );
  const snackbarRef = query(ref(db, "da6d/" + "motion/" + "snackbar"));
  const timeStampRef = query(ref(db, "da6d/" + "motion/" + "timeStamp"));
  // const [timePercent, setTimePercent] = useState(0);
  const action = (key) => (
    <Fragment>
      <Button
        onClick={() => {
          closeSnackbar(key);
          update(motionNotificationRef, { notification: false });
          update(motionNotificationRef, { snackbar: false });
          update(da6dRef, { update: true });
        }}
      >
        Dismiss
      </Button>
    </Fragment>
  );
  // var counter = 1;
  const handleTimestamp = () => {
    // setTimePercent(0);
    // onValue(totalSittingTimeRef, (snapshot) => {
    //   setTotalSittingTime(snapshot.val());
    // });
    // onValue(timeStampRef, (snapshot) => {
    // const lastTimeStamp = timeStamp;
    const currentTimeStamp = new Date().getTime();
    // const timeStampDiff = (currentTimeStamp - lastTimeStamp) / 60000;
    // console.log("totalSittingTime is " + totalSittingTime);
    // console.log("timeStampDiff is " + timeStampDiff);
    // setTimePercent(totalSittingTime / timeStampDiff);
    // console.log(
    //   "timePercent is " + (totalSittingTime * 100) / timeStampDiff + "%"
    // );
    // update(motionNotificationRef, {
    //   timePercent: Math.round((totalSittingTime * 100) / timeStampDiff),
    // });
    // update(motionNotificationRef, {
    //   timePercent: 0,
    // });
    // setTimeStamp(currentTimeStamp);
    update(motionNotificationRef, { timeStamp: currentTimeStamp });
    // });
    console.log("last time is " + new Date(currentTimeStamp));
    update(motionNotificationRef, { totalSittingTime: 0 });
    // setTotalSittingTime(0);
    // console.log("totalSittingTime updated");
  };

  // const handleClickVariant = (variant) => () => {
  //   // variant could be success, error, warning, info, or default
  //   enqueueSnackbar("You've sat here too long, take a break!", {
  //     variant,
  //     action,
  //     persist: true,
  //     preventDuplicate: true,
  //   });
  //   update(motionNotificationRef, { notification: true });
  // };

  useEffect(() => {
    // setLoading(true);
    onValue(totalSittingTimeRef, (snapshot) => {
      if (snapshot.val() >= 30) {
        console.log(snapshot.val());
        enqueueSnackbar("You've sat here too long, take a break!", {
          variant: "info",
          action,
          persist: true,
          preventDuplicate: true,
        });
        update(motionNotificationRef, { notification: true });
        update(motionNotificationRef, { snackbar: true });
      }
    });
    onValue(snackbarRef, (snapshot) => {
      setSnackbar(snapshot.val());
    });
    onValue(notificationRef, (snapshot) => {
      setSendNotification(snapshot.val());
    });
  }, []);
  const loadTasksPage = (event) => {
    setRenderTodos(true);
  };

  const loadEnvironmentPage = (event) => {
    setRenderTodos(false);
  };
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar className="tool-bar">
          <Typography variant="h6" noWrap component="div">
            Time Table
          </Typography>
          {/* <Button
            sx={{
              position: "fixed",
              right: 10,
            }}
            variant="contained"
            color="info"
            onClick={handleTimestamp}
          >
            Restart
          </Button> */}
          {/* <Button
            sx={{
              position: "fixed",
              right: 160,
            }}
            variant="contained"
            color="info"
            onClick={handleClickVariant("info")}
          >
            Test Notification
          </Button> */}
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto" }}>
          {/* <Divider /> */}
          <List>
            <ListItem
              button
              key="Tasks"
              onClick={loadTasksPage}
              sx={{
                ":hover": {
                  color: "#1E3877",
                },
              }}
            >
              <ListItemIcon>
                {" "}
                <PlaylistAddCheckIcon />{" "}
              </ListItemIcon>
              <ListItemText primary="Tasks" />
            </ListItem>
            <ListItem
              button
              key="Environment"
              color="primary"
              onClick={loadEnvironmentPage}
              sx={{
                ":hover": {
                  color: "#1E3877",
                },
              }}
            >
              <ListItemIcon>
                {" "}
                <DeviceThermostatIcon />{" "}
              </ListItemIcon>
              <ListItemText primary="Environment" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        {renderTodos ? <Tasks /> : <Environment />}
      </Box>
      {renderTodos ? <Monitor /> : null}
    </Box>
  );
}

export default function Home() {
  return (
    <SnackbarProvider maxSnack={4}>
      <HomePage />
    </SnackbarProvider>
  );
}

// "browser_action": {
//   "default_icon": "./logo.png",
//   "default_popup": "pages/popup/popout.html"
// },
// "content_security_policy": "script-src 'self' https://example.com; object-src 'self'"
